import { EAddedAdsType } from '../../types/addedAdsType';
export var ADDED_ADS_TYPE_ANSWERS = [{
  label: 'Нет',
  value: EAddedAdsType.No
}, {
  label: 'Да, как собственник',
  value: EAddedAdsType.Owner
}, {
  label: ' Да, как риелтор',
  value: EAddedAdsType.Realtor
}, {
  label: 'Да, как сотрудник агентства',
  value: EAddedAdsType.Employee
}, {
  label: 'Да, как агентство',
  value: EAddedAdsType.Agency
}];